
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as ZWNoYXJ0cw from 'echarts';
import * as d2FzbTpqcy1zdHJpbmc from './AppStrengthWeb-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_ZWNoYXJ0cw_ = ZWNoYXJ0cw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
    'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.minHeight_$external_prop_setter' : (_this, v) => _this.minHeight = v,
    'org.w3c.dom.css.minWidth_$external_prop_setter' : (_this, v) => _this.minWidth = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.document_$external_prop_getter' : (_this) => _this.document,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.title_$external_prop_getter' : (_this) => _this.title,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.key_$external_fun' : (_this, p0) => _this.key(p0),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.onclick_$external_prop_setter' : (_this, v) => _this.onclick = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_3' : () => ({}),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.URL_$external_fun' : (p0, p1, isDefault0) => new URL(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.url.searchParams_$external_prop_getter' : (_this) => _this.searchParams,
    'org.w3c.dom.url.URLSearchParams_$external_fun' : (p0, isDefault0) => new URLSearchParams(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.url.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.persistModule' : 
        (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
            await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
    ,
    'kotlinx.io.node.getRequire' : () => { 
        const importMeta = import.meta;
        return globalThis.module.default.createRequire(importMeta.url);
    }
    ,
    'kotlinx.io.node.requireModule' : 
        (require, mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
        }
    ,
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
    'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'dev.whyoleg.cryptography.random.getByte' : (obj, index) => obj[index],
    'dev.whyoleg.cryptography.random.getCrypto' : () => (globalThis ? globalThis.crypto : (window.crypto || window.msCrypto)),
    'dev.whyoleg.cryptography.random.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'dev.whyoleg.cryptography.random.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'dev.whyoleg.cryptography.random.length_$external_prop_getter' : (_this) => _this.length,
    'dev.whyoleg.cryptography.random.subarray_$external_fun' : (_this, p0, p1) => _this.subarray(p0, p1),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
              case 'pointercancel':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'com.tunesoftware.appstrength.charts.installChartWheelForwarding' : (element) => 
        (() => {
            if (!element.__appStrengthWheelHandler) {
                const handler = (event) => {
                    const interopContainer = element.parentElement?.parentElement;
                    const shadowContainer = interopContainer?.previousElementSibling;
                    const composeCanvas = shadowContainer?.shadowRoot?.querySelector("canvas");
                    if (!composeCanvas) return;

                    composeCanvas.dispatchEvent(new WheelEvent("wheel", {
                        bubbles: true,
                        cancelable: true,
                        composed: true,
                        clientX: event.clientX,
                        clientY: event.clientY,
                        screenX: event.screenX,
                        screenY: event.screenY,
                        deltaX: event.deltaX,
                        deltaY: event.deltaY,
                        deltaZ: event.deltaZ,
                        deltaMode: event.deltaMode,
                        ctrlKey: event.ctrlKey,
                        shiftKey: event.shiftKey,
                        altKey: event.altKey,
                        metaKey: event.metaKey
                    }));
                };
                element.__appStrengthWheelHandler = handler;
                element.addEventListener("wheel", handler, { capture: true, passive: true });
            }
        })()
        ,
    'com.tunesoftware.appstrength.charts.setChartOcclusion' : (element, rightWidthPx, snackbarLeftPx, snackbarTopPx, snackbarRightPx, snackbarBottomPx) => 
        (() => {
            const wrapper = element.parentElement;
            const chartRect = element.getBoundingClientRect();
            const drawerLeft = document.documentElement.clientWidth - rightWidthPx;
            const rightInset = rightWidthPx > 0
                ? Math.max(0, Math.ceil(chartRect.right - drawerLeft))
                : 0;
            const visibleRight = Math.max(0, chartRect.width - rightInset);
            const holeLeft = Math.max(0, snackbarLeftPx - chartRect.left);
            const holeTop = Math.max(0, snackbarTopPx - chartRect.top);
            const holeRight = Math.min(visibleRight, snackbarRightPx - chartRect.left);
            const holeBottom = Math.min(chartRect.height, snackbarBottomPx - chartRect.top);
            const intersectsSnackbar = snackbarRightPx > snackbarLeftPx &&
                snackbarBottomPx > snackbarTopPx &&
                holeRight > holeLeft &&
                holeBottom > holeTop;

            element.style.setProperty(
                "transition",
                intersectsSnackbar ? "none" : "clip-path 250ms ease"
            );
            if (intersectsSnackbar) {
                element.style.setProperty(
                    "clip-path",
                    "polygon(evenodd, " +
                        "0 0, " + visibleRight + "px 0, " +
                        visibleRight + "px " + chartRect.height + "px, " +
                        "0 " + chartRect.height + "px, 0 0, " +
                        holeLeft + "px " + holeTop + "px, " +
                        holeLeft + "px " + holeBottom + "px, " +
                        holeRight + "px " + holeBottom + "px, " +
                        holeRight + "px " + holeTop + "px, " +
                        holeLeft + "px " + holeTop + "px)"
                );
            } else {
                element.style.setProperty(
                    "clip-path",
                    "inset(0 " + rightInset + "px 0 0)"
                );
            }
            element.style.setProperty(
                "will-change",
                rightInset > 0 || intersectsSnackbar ? "clip-path" : ""
            );
            wrapper?.style.setProperty(
                "pointer-events",
                rightWidthPx > 0 || intersectsSnackbar ? "none" : ""
            );
        })()
        ,
    'com.tunesoftware.appstrength.charts.removeChartWheelForwarding' : (element) => 
        (() => {
            const handler = element.__appStrengthWheelHandler;
            if (handler) {
                element.removeEventListener("wheel", handler, { capture: true });
                delete element.__appStrengthWheelHandler;
            }
        })()
        ,
    'com.tunesoftware.appstrength.charts.setOption_$external_fun' : (_this, p0, p1) => _this.setOption(p0, p1),
    'com.tunesoftware.appstrength.charts.setTheme_$external_fun' : (_this, p0) => _this.setTheme(p0),
    'com.tunesoftware.appstrength.charts.on_$external_fun' : (_this, p0, p1) => _this.on(p0, p1),
    'com.tunesoftware.appstrength.charts.off_$external_fun' : (_this, p0, p1) => _this.off(p0, p1),
    'com.tunesoftware.appstrength.charts.getZr_$external_fun' : (_this, ) => _this.getZr(),
    'com.tunesoftware.appstrength.charts.resize_$external_fun' : (_this, ) => _this.resize(),
    'com.tunesoftware.appstrength.charts.dispose_$external_fun' : (_this, ) => _this.dispose(),
    'com.tunesoftware.appstrength.charts.name_$external_prop_getter' : (_this) => _this.name,
    'com.tunesoftware.appstrength.charts.on_$external_fun_1' : (_this, p0, p1) => _this.on(p0, p1),
    'com.tunesoftware.appstrength.charts.off_$external_fun_1' : (_this, p0, p1) => _this.off(p0, p1),
    'com.tunesoftware.appstrength.charts.setCursorStyle_$external_fun' : (_this, p0) => _this.setCursorStyle(p0),
    'com.tunesoftware.appstrength.charts.init_$external_fun' : (p0, p1) => _ref_ZWNoYXJ0cw_.init(p0, p1),
    'com.tunesoftware.appstrength.charts.newBarEChartsOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarTooltipOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarGridOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarValueAxisOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarAxisLabelOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarCategoryAxisOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarSeriesOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarItemStyleOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newBarLabelOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.tooltip_$external_prop_setter' : (_this, v) => _this.tooltip = v,
    'com.tunesoftware.appstrength.charts.grid_$external_prop_setter' : (_this, v) => _this.grid = v,
    'com.tunesoftware.appstrength.charts.xAxis_$external_prop_setter' : (_this, v) => _this.xAxis = v,
    'com.tunesoftware.appstrength.charts.yAxis_$external_prop_setter' : (_this, v) => _this.yAxis = v,
    'com.tunesoftware.appstrength.charts.series_$external_prop_setter' : (_this, v) => _this.series = v,
    'com.tunesoftware.appstrength.charts.trigger_$external_prop_setter' : (_this, v) => _this.trigger = v,
    'com.tunesoftware.appstrength.charts.formatter_$external_prop_setter' : (_this, v) => _this.formatter = v,
    'com.tunesoftware.appstrength.charts.__convertKotlinClosureToJsClosure_((Js)->Js)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js)'](f, p0)),
    'com.tunesoftware.appstrength.charts.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'com.tunesoftware.appstrength.charts.right_$external_prop_setter' : (_this, v) => _this.right = v,
    'com.tunesoftware.appstrength.charts.bottom_$external_prop_setter' : (_this, v) => _this.bottom = v,
    'com.tunesoftware.appstrength.charts.containLabel_$external_prop_setter' : (_this, v) => _this.containLabel = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.min_$external_prop_setter' : (_this, v) => _this.min = v,
    'com.tunesoftware.appstrength.charts.max_$external_prop_setter' : (_this, v) => _this.max = v,
    'com.tunesoftware.appstrength.charts.interval_$external_prop_setter' : (_this, v) => _this.interval = v,
    'com.tunesoftware.appstrength.charts.axisLabel_$external_prop_setter' : (_this, v) => _this.axisLabel = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_1' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.inverse_$external_prop_setter' : (_this, v) => _this.inverse = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_2' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.barWidth_$external_prop_setter' : (_this, v) => _this.barWidth = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter_1' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.itemStyle_$external_prop_setter' : (_this, v) => _this.itemStyle = v,
    'com.tunesoftware.appstrength.charts.label_$external_prop_setter' : (_this, v) => _this.label = v,
    'com.tunesoftware.appstrength.charts.dataIndex_$external_prop_getter' : (_this) => _this.dataIndex,
    'com.tunesoftware.appstrength.charts.formatter_$external_prop_setter_1' : (_this, v) => _this.formatter = v,
    'com.tunesoftware.appstrength.charts.color_$external_prop_setter' : (_this, v) => _this.color = v,
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'com.tunesoftware.appstrength.charts.formatter_$external_prop_setter_2' : (_this, v) => _this.formatter = v,
    'com.tunesoftware.appstrength.charts.dataIndex_$external_prop_getter_1' : (_this) => _this.dataIndex,
    'com.tunesoftware.appstrength.charts.newEChartsOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newTitleOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newTooltipOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.appendSuffix' : (value, suffix) => value + suffix,
    'com.tunesoftware.appstrength.charts.newLegendOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newGraphicTextOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newGraphicTextStyle' : () => ({}),
    'com.tunesoftware.appstrength.charts.newGridOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newCategoryAxisOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newCategoryAxisLabelOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newCategoryAxisTickOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.setVisibleCategoryMarkers' : (axisLabel, axisTick, visibleLabels) => (() => {
            const visible = new Set(visibleLabels);
            axisLabel.interval = 0;
            axisLabel.formatter = (value) => visible.has(value) ? value : '';
            axisTick.interval = (index, value) => visible.has(value);
        })(),
    'com.tunesoftware.appstrength.charts.newValueAxisOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newAxisLabelOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.setDurationAxisLabelFormatter' : (axisLabel) => axisLabel.formatter = (value) => {
            const totalSeconds = Math.max(0, Math.round(value));
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            if (hours > 0) {
                return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
            }
            if (minutes > 0) {
                return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
            }
            return `${seconds}s`;
        },
    'com.tunesoftware.appstrength.charts.setAxisMaximum' : (axis, maximum) => axis.max = maximum,
    'com.tunesoftware.appstrength.charts.newSplitLineOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newDimensionBarSeriesOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newDimensionBarDataOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newItemStyleOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newSeriesTooltipOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newLineSeriesOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newLineStyleOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newAreaStyleOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newEndLabelOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newCustomSeriesOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.legendIndex' : (event) => (() => {
            let target = event.topTarget;
            while (target && target.__legendDataIndex == null) {
                target = target.parent;
            }
            return target?.__legendDataIndex ?? -1;
        })(),
    'com.tunesoftware.appstrength.charts.newMarkLineOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newMarkLineLabelOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newMarkLineRichOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newMarkLineRichStyle' : () => ({}),
    'com.tunesoftware.appstrength.charts.newMarkLineRichBackground' : () => ({}),
    'com.tunesoftware.appstrength.charts.newMarkLineDataOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.newMarkLineDataLabelOption' : () => ({}),
    'com.tunesoftware.appstrength.charts.renderMarkLineConnector' : (params, api, xAxis, length, color, opacity, width, dashLength, dashGap) => (() => {
            const x = api.coord([xAxis, 0])[0];
            const top = params.coordSys.y;
            return {
                type: 'line',
                silent: true,
                shape: {
                    x1: x + width / 2,
                    y1: top,
                    x2: x + width / 2,
                    y2: top - length
                },
                style: {
                    stroke: color,
                    lineWidth: width,
                    opacity: opacity,
                    lineDash: [dashLength, dashGap]
                }
            };
        })(),
    'com.tunesoftware.appstrength.charts.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'com.tunesoftware.appstrength.charts.tooltip_$external_prop_setter_1' : (_this, v) => _this.tooltip = v,
    'com.tunesoftware.appstrength.charts.legend_$external_prop_setter' : (_this, v) => _this.legend = v,
    'com.tunesoftware.appstrength.charts.grid_$external_prop_setter_1' : (_this, v) => _this.grid = v,
    'com.tunesoftware.appstrength.charts.xAxis_$external_prop_setter_1' : (_this, v) => _this.xAxis = v,
    'com.tunesoftware.appstrength.charts.yAxis_$external_prop_setter_1' : (_this, v) => _this.yAxis = v,
    'com.tunesoftware.appstrength.charts.series_$external_prop_setter_1' : (_this, v) => _this.series = v,
    'com.tunesoftware.appstrength.charts.graphic_$external_prop_setter' : (_this, v) => _this.graphic = v,
    'com.tunesoftware.appstrength.charts.ResizeObserver_$external_fun' : (p0) => new ResizeObserver(p0),
    'com.tunesoftware.appstrength.charts.observe_$external_fun' : (_this, p0) => _this.observe(p0),
    'com.tunesoftware.appstrength.charts.disconnect_$external_fun' : (_this, ) => _this.disconnect(),
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter_1' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.text_$external_prop_setter' : (_this, v) => _this.text = v,
    'com.tunesoftware.appstrength.charts.trigger_$external_prop_setter_1' : (_this, v) => _this.trigger = v,
    'com.tunesoftware.appstrength.charts.valueFormatter_$external_prop_setter' : (_this, v) => _this.valueFormatter = v,
    'com.tunesoftware.appstrength.charts.__convertKotlinClosureToJsClosure_((Js,Int)->Js)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Int)->Js)'](f, p0, p1)),
    'com.tunesoftware.appstrength.charts.show_$external_prop_getter' : (_this) => _this.show,
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter_2' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter_2' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.bottom_$external_prop_setter_1' : (_this, v) => _this.bottom = v,
    'com.tunesoftware.appstrength.charts.selectedMode_$external_prop_setter' : (_this, v) => _this.selectedMode = v,
    'com.tunesoftware.appstrength.charts.left_$external_prop_setter_1' : (_this, v) => _this.left = v,
    'com.tunesoftware.appstrength.charts.right_$external_prop_setter_1' : (_this, v) => _this.right = v,
    'com.tunesoftware.appstrength.charts.bottom_$external_prop_setter_2' : (_this, v) => _this.bottom = v,
    'com.tunesoftware.appstrength.charts.containLabel_$external_prop_setter_1' : (_this, v) => _this.containLabel = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_3' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.left_$external_prop_setter_2' : (_this, v) => _this.left = v,
    'com.tunesoftware.appstrength.charts.bottom_$external_prop_setter_3' : (_this, v) => _this.bottom = v,
    'com.tunesoftware.appstrength.charts.silent_$external_prop_setter' : (_this, v) => _this.silent = v,
    'com.tunesoftware.appstrength.charts.style_$external_prop_setter' : (_this, v) => _this.style = v,
    'com.tunesoftware.appstrength.charts.text_$external_prop_setter_1' : (_this, v) => _this.text = v,
    'com.tunesoftware.appstrength.charts.fill_$external_prop_setter' : (_this, v) => _this.fill = v,
    'com.tunesoftware.appstrength.charts.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'com.tunesoftware.appstrength.charts.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_4' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.boundaryGap_$external_prop_setter' : (_this, v) => _this.boundaryGap = v,
    'com.tunesoftware.appstrength.charts.inverse_$external_prop_setter_1' : (_this, v) => _this.inverse = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter_3' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.axisLabel_$external_prop_getter' : (_this) => _this.axisLabel,
    'com.tunesoftware.appstrength.charts.axisLabel_$external_prop_setter_1' : (_this, v) => _this.axisLabel = v,
    'com.tunesoftware.appstrength.charts.axisTick_$external_prop_getter' : (_this) => _this.axisTick,
    'com.tunesoftware.appstrength.charts.axisTick_$external_prop_setter' : (_this, v) => _this.axisTick = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_5' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.position_$external_prop_setter_1' : (_this, v) => _this.position = v,
    'com.tunesoftware.appstrength.charts.name_$external_prop_setter_1' : (_this, v) => _this.name = v,
    'com.tunesoftware.appstrength.charts.nameLocation_$external_prop_setter' : (_this, v) => _this.nameLocation = v,
    'com.tunesoftware.appstrength.charts.nameRotate_$external_prop_setter' : (_this, v) => _this.nameRotate = v,
    'com.tunesoftware.appstrength.charts.nameGap_$external_prop_setter' : (_this, v) => _this.nameGap = v,
    'com.tunesoftware.appstrength.charts.splitLine_$external_prop_setter' : (_this, v) => _this.splitLine = v,
    'com.tunesoftware.appstrength.charts.axisLabel_$external_prop_setter_2' : (_this, v) => _this.axisLabel = v,
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter_3' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.formatter_$external_prop_setter_3' : (_this, v) => _this.formatter = v,
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter_4' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.name_$external_prop_setter_2' : (_this, v) => _this.name = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_6' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.stack_$external_prop_setter' : (_this, v) => _this.stack = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter_4' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.itemStyle_$external_prop_setter_1' : (_this, v) => _this.itemStyle = v,
    'com.tunesoftware.appstrength.charts.tooltip_$external_prop_setter_2' : (_this, v) => _this.tooltip = v,
    'com.tunesoftware.appstrength.charts.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'com.tunesoftware.appstrength.charts.itemStyle_$external_prop_setter_2' : (_this, v) => _this.itemStyle = v,
    'com.tunesoftware.appstrength.charts.color_$external_prop_setter_1' : (_this, v) => _this.color = v,
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter_5' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.valueFormatter_$external_prop_setter_1' : (_this, v) => _this.valueFormatter = v,
    'com.tunesoftware.appstrength.charts.name_$external_prop_setter_3' : (_this, v) => _this.name = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_7' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.yAxisIndex_$external_prop_setter' : (_this, v) => _this.yAxisIndex = v,
    'com.tunesoftware.appstrength.charts.smooth_$external_prop_setter' : (_this, v) => _this.smooth = v,
    'com.tunesoftware.appstrength.charts.smoothMonotone_$external_prop_setter' : (_this, v) => _this.smoothMonotone = v,
    'com.tunesoftware.appstrength.charts.showSymbol_$external_prop_setter' : (_this, v) => _this.showSymbol = v,
    'com.tunesoftware.appstrength.charts.symbolSize_$external_prop_setter' : (_this, v) => _this.symbolSize = v,
    'com.tunesoftware.appstrength.charts.__convertKotlinClosureToJsClosure_((Js,Js)->Int)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Int)'](f, p0, p1)),
    'com.tunesoftware.appstrength.charts.clip_$external_prop_setter' : (_this, v) => _this.clip = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter_5' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.lineStyle_$external_prop_setter' : (_this, v) => _this.lineStyle = v,
    'com.tunesoftware.appstrength.charts.itemStyle_$external_prop_setter_3' : (_this, v) => _this.itemStyle = v,
    'com.tunesoftware.appstrength.charts.areaStyle_$external_prop_setter' : (_this, v) => _this.areaStyle = v,
    'com.tunesoftware.appstrength.charts.endLabel_$external_prop_setter' : (_this, v) => _this.endLabel = v,
    'com.tunesoftware.appstrength.charts.tooltip_$external_prop_setter_3' : (_this, v) => _this.tooltip = v,
    'com.tunesoftware.appstrength.charts.markLine_$external_prop_setter' : (_this, v) => _this.markLine = v,
    'com.tunesoftware.appstrength.charts.dataIndex_$external_prop_getter_2' : (_this) => _this.dataIndex,
    'com.tunesoftware.appstrength.charts.color_$external_prop_setter_2' : (_this, v) => _this.color = v,
    'com.tunesoftware.appstrength.charts.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_8' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.opacity_$external_prop_setter_1' : (_this, v) => _this.opacity = v,
    'com.tunesoftware.appstrength.charts.opacity_$external_prop_setter_2' : (_this, v) => _this.opacity = v,
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter_6' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.formatter_$external_prop_setter_4' : (_this, v) => _this.formatter = v,
    'com.tunesoftware.appstrength.charts.color_$external_prop_setter_3' : (_this, v) => _this.color = v,
    'com.tunesoftware.appstrength.charts.distance_$external_prop_setter' : (_this, v) => _this.distance = v,
    'com.tunesoftware.appstrength.charts.fontWeight_$external_prop_setter' : (_this, v) => _this.fontWeight = v,
    'com.tunesoftware.appstrength.charts.symbol_$external_prop_setter' : (_this, v) => _this.symbol = v,
    'com.tunesoftware.appstrength.charts.silent_$external_prop_setter_1' : (_this, v) => _this.silent = v,
    'com.tunesoftware.appstrength.charts.lineStyle_$external_prop_setter_1' : (_this, v) => _this.lineStyle = v,
    'com.tunesoftware.appstrength.charts.label_$external_prop_setter_1' : (_this, v) => _this.label = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter_6' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'com.tunesoftware.appstrength.charts.type_$external_prop_setter_9' : (_this, v) => _this.type = v,
    'com.tunesoftware.appstrength.charts.coordinateSystem_$external_prop_setter' : (_this, v) => _this.coordinateSystem = v,
    'com.tunesoftware.appstrength.charts.silent_$external_prop_setter_2' : (_this, v) => _this.silent = v,
    'com.tunesoftware.appstrength.charts.clip_$external_prop_setter_1' : (_this, v) => _this.clip = v,
    'com.tunesoftware.appstrength.charts.animation_$external_prop_setter' : (_this, v) => _this.animation = v,
    'com.tunesoftware.appstrength.charts.z_$external_prop_setter' : (_this, v) => _this.z = v,
    'com.tunesoftware.appstrength.charts.data_$external_prop_setter_7' : (_this, v) => _this.data = v,
    'com.tunesoftware.appstrength.charts.tooltip_$external_prop_setter_4' : (_this, v) => _this.tooltip = v,
    'com.tunesoftware.appstrength.charts.renderItem_$external_prop_setter' : (_this, v) => _this.renderItem = v,
    'com.tunesoftware.appstrength.charts.__convertKotlinClosureToJsClosure_((Js,Js)->Js)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Js)'](f, p0, p1)),
    'com.tunesoftware.appstrength.charts.dataIndex_$external_prop_getter_3' : (_this) => _this.dataIndex,
    'com.tunesoftware.appstrength.charts.show_$external_prop_setter_7' : (_this, v) => _this.show = v,
    'com.tunesoftware.appstrength.charts.position_$external_prop_setter_2' : (_this, v) => _this.position = v,
    'com.tunesoftware.appstrength.charts.distance_$external_prop_setter_1' : (_this, v) => _this.distance = v,
    'com.tunesoftware.appstrength.charts.opacity_$external_prop_setter_3' : (_this, v) => _this.opacity = v,
    'com.tunesoftware.appstrength.charts.fontSize_$external_prop_setter_1' : (_this, v) => _this.fontSize = v,
    'com.tunesoftware.appstrength.charts.rich_$external_prop_setter' : (_this, v) => _this.rich = v,
    'com.tunesoftware.appstrength.charts.xAxis_$external_prop_setter_2' : (_this, v) => _this.xAxis = v,
    'com.tunesoftware.appstrength.charts.lineStyle_$external_prop_setter_2' : (_this, v) => _this.lineStyle = v,
    'com.tunesoftware.appstrength.charts.label_$external_prop_setter_2' : (_this, v) => _this.label = v,
    'com.tunesoftware.appstrength.charts.android_$external_prop_setter' : (_this, v) => _this.android = v,
    'com.tunesoftware.appstrength.charts.ios_$external_prop_setter' : (_this, v) => _this.ios = v,
    'com.tunesoftware.appstrength.charts.width_$external_prop_setter_1' : (_this, v) => _this.width = v,
    'com.tunesoftware.appstrength.charts.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'com.tunesoftware.appstrength.charts.backgroundColor_$external_prop_setter' : (_this, v) => _this.backgroundColor = v,
    'com.tunesoftware.appstrength.charts.image_$external_prop_setter' : (_this, v) => _this.image = v,
    'com.tunesoftware.appstrength.charts.formatter_$external_prop_setter_5' : (_this, v) => _this.formatter = v,
    'com.tunesoftware.appstrength.charts.distance_$external_prop_setter_2' : (_this, v) => _this.distance = v,
    'com.tunesoftware.appstrength.ui.updateDropdownHost' : (element, expanded, labels, iconSvgs, hasIcons, selectedIndex, menuBackground, menuTextColor, menuHoverColor, accessibleLabel, onHoverStart, onHoverEnd, onToggle, onSelect, onDismiss) => 
        (() => {
            const cleanup = element.__appStrengthDropdownCleanup;
            if (cleanup) cleanup();

            element.parentElement?.style.setProperty("z-index", "1000");
            element.setAttribute("aria-label", accessibleLabel);
            element.setAttribute("aria-expanded", expanded ? "true" : "false");
            element.onmouseenter = () => onHoverStart();
            element.onmouseleave = () => onHoverEnd();
            element.onclick = (event) => {
                event.stopPropagation();
                onToggle();
            };

            if (!expanded) {
                element.__appStrengthDropdownCleanup = null;
                return;
            }

            const rect = element.getBoundingClientRect();
            const viewportPadding = 8;
            const menuGap = 4;
            const viewportWidth = document.documentElement.clientWidth;
            const viewportHeight = document.documentElement.clientHeight;
            const availableWidth = Math.max(0, viewportWidth - (viewportPadding * 2));
            const menu = document.createElement("div");
            menu.setAttribute("role", "listbox");
            Object.assign(menu.style, {
                position: "fixed",
                left: rect.left + "px",
                top: (rect.bottom + menuGap) + "px",
                width: "max-content",
                minWidth: Math.min(rect.width, availableWidth) + "px",
                maxWidth: availableWidth + "px",
                padding: "4px 0",
                boxSizing: "border-box",
                overflowX: "hidden",
                borderRadius: "4px",
                background: menuBackground,
                color: menuTextColor,
                boxShadow: "0 4px 12px rgba(0,0,0,0.24)",
                fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                fontSize: "14px",
                zIndex: "2147483647"
            });

            for (let index = 0; index < labels.length; index++) {
                const item = document.createElement("button");
                item.type = "button";
                item.setAttribute("role", "option");
                item.setAttribute("aria-selected", index === selectedIndex ? "true" : "false");
                Object.assign(item.style, {
                    display: hasIcons ? "flex" : "block",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: "100%",
                    padding: "10px 12px",
                    boxSizing: "border-box",
                    border: "0",
                    background: "transparent",
                    color: "inherit",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    font: "inherit",
                    fontWeight: index === selectedIndex ? "600" : "400"
                });

                if (hasIcons) {
                    const icon = document.createElement("span");
                    icon.setAttribute("aria-hidden", "true");
                    Object.assign(icon.style, {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flex: "0 0 18px",
                        width: "18px",
                        height: "18px",
                        marginRight: "8px"
                    });
                    if (iconSvgs[index]) icon.innerHTML = iconSvgs[index];
                    item.appendChild(icon);
                }

                const label = document.createElement("span");
                label.textContent = labels[index];
                Object.assign(label.style, {
                    minWidth: "0",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                });
                item.appendChild(label);
                item.onmouseenter = () => { item.style.background = menuHoverColor; };
                item.onmouseleave = () => { item.style.background = "transparent"; };
                item.onclick = (event) => {
                    event.stopPropagation();
                    onSelect(index);
                };
                menu.appendChild(item);
            }

            document.body.appendChild(menu);

            const menuRect = menu.getBoundingClientRect();
            const maxLeft = Math.max(
                viewportPadding,
                viewportWidth - viewportPadding - menuRect.width
            );
            menu.style.left = Math.min(Math.max(rect.left, viewportPadding), maxLeft) + "px";

            const spaceBelow = viewportHeight - rect.bottom - menuGap - viewportPadding;
            const spaceAbove = rect.top - menuGap - viewportPadding;
            const openAbove = menuRect.height > spaceBelow && spaceAbove > spaceBelow;
            const availableHeight = Math.max(0, openAbove ? spaceAbove : spaceBelow);
            menu.style.maxHeight = availableHeight + "px";
            menu.style.overflowY = "auto";
            if (openAbove) {
                menu.style.top = Math.max(
                    viewportPadding,
                    rect.top - menuGap - Math.min(menuRect.height, availableHeight)
                ) + "px";
            }

            const dismiss = (event) => {
                if (!menu.contains(event.target) && !element.contains(event.target)) {
                    onDismiss();
                }
            };
            const dismissOnWheel = () => onDismiss();
            const dismissOnResize = () => onDismiss();
            setTimeout(() => document.addEventListener("pointerdown", dismiss, true), 0);
            window.addEventListener("wheel", dismissOnWheel, { passive: true });
            window.addEventListener("resize", dismissOnResize);

            element.__appStrengthDropdownCleanup = () => {
                document.removeEventListener("pointerdown", dismiss, true);
                window.removeEventListener("wheel", dismissOnWheel);
                window.removeEventListener("resize", dismissOnResize);
                menu.remove();
            };
        })()
        ,
    'com.tunesoftware.appstrength.ui.__convertKotlinClosureToJsClosure_((Int)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Int)->Unit)'](f, p0)),
    'com.tunesoftware.appstrength.ui.releaseDropdownHost' : (element) => 
        (() => {
            const cleanup = element.__appStrengthDropdownCleanup;
            if (cleanup) cleanup();
            element.__appStrengthDropdownCleanup = null;
            element.onmouseenter = null;
            element.onmouseleave = null;
            element.onclick = null;
        })()
        ,
    'com.tunesoftware.appstrength.mainframe.updateDrawerDomScrim' : (element, visible, drawerWidthPx, onDismissRequest) => 
        (() => {
            const wrapper = element.parentElement;
            wrapper?.style.setProperty("z-index", "2147483646");
            wrapper?.style.setProperty("pointer-events", "none");

            Object.assign(element.style, {
                background: "rgba(0, 0, 0, 0.32)",
                clipPath: "inset(0 " + drawerWidthPx + "px 0 0)",
                opacity: visible ? "1" : "0",
                pointerEvents: visible ? "auto" : "none",
                transition: "opacity 250ms ease"
            });
            element.onclick = visible ? onDismissRequest : null;
        })()

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    